<template>
	<div>
		<v-row>
			<v-col>
				<v-badge
					:value="thereAreFiltersApplied"
					color="primary"
					overlap
					right
				>
					<v-btn
						color="secondary"
						@click="openClientiFiltersDialog()"
						:disabled="isLoading"
					>
						Filtri
					</v-btn>
				</v-badge>
			</v-col>
			
			<v-col cols="4">
				<v-text-field
					v-model="search"
					append-icon="mdi-magnify"
					label="Cerca"
					single-line
					hide-details
					outlined
					dense
				></v-text-field>
			</v-col>
			
			<!--<v-col class="text-center">-->
			<!--	<v-btn-->
			<!--		color="secondary"-->
			<!--		@click="openSendCredentialsDialog()"-->
			<!--		:disabled="isLoading"-->
			<!--	>-->
			<!--		<v-icon size="20">mdi-key</v-icon>-->
			<!--	</v-btn>-->
			<!--</v-col>-->
			
			<v-col class="text-right">
				<v-btn color="secondary" @click="openClienteDialog('store')">Aggiungi Cliente</v-btn>
			</v-col>
		</v-row>
		
		<v-row>
			<v-col>
				<clienti-data-table
					ref="clientiDataTable"
					:search="search"
					@is-loading="isLoadingClientiDataTable = $event"
				></clienti-data-table>
			</v-col>
		</v-row>
		
		<!--<v-dialog-->
		<!--	v-model="filtersDialog"-->
		<!--	scrollable-->
		<!--	persistent-->
		<!--	width="800px"-->
		<!--&gt;-->
		<!--	<clienti-filters-->
		<!--		@close="filtersDialog = false"-->
		<!--	></clienti-filters>-->
		<!--</v-dialog>-->
		
		<v-dialog
			:value="sendCredentialsDialog"
			persistent
			width="unset"
		>
			<send-credentials
				@close="sendCredentialsDialog = false"
			></send-credentials>
		</v-dialog>
	
	</div>
</template>

<script>
import {eventBus} from "@/event-bus";
import {mapGetters} from "vuex";
export default {
	data() {
		return {
			isLoadingClientiDataTable: false,
			// clienteKey: 0,
			search: null,
			showClienteDialog: false,
			cliente: null,
			action: null,
			
			// accordiKey: 0,
			// showAccordiDataTableDialog: false,
			// cliente_id: null,
			
			filtersDialog: false,
			
			sendCredentialsDialog: false,
		}
	},
	
	computed: {
		...mapGetters({
			thereAreFiltersApplied: 'clientiFilters/thereAreFiltersApplied'
		}),
		isLoading() {
			return this.isLoadingClientiDataTable;
		}
	},
	
	methods: {
		openClienteDialog(action) {
			this.$refs.clientiDataTable.openClienteDialog(action);
		},
		openSendCredentialsDialog() {
			this.sendCredentialsDialog = true;
		},
		openClientiFiltersDialog() {
			this.$refs.clientiDataTable.openClientiFiltersDialog();
		}
	}
}
</script>

<style scoped>

</style>